import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, BookOpenIcon, CheckIcon, ImageIcon, SaveIcon, TagIcon, CalendarIcon, ClockIcon, AlertCircleIcon, EyeIcon, MenuIcon, XIcon, FeatherIcon, LogOutIcon, HomeIcon } from 'lucide-react';
export function AdminBlogCreate() {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('');
  const [excerpt, setExcerpt] = useState('');
  const [featuredImage, setFeaturedImage] = useState('');
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [slug, setSlug] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [activeTab, setActiveTab] = useState('content');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  // Generate slug from title
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTitle = e.target.value;
    setTitle(newTitle);
    if (!slug || slug === generateSlug(title)) {
      setSlug(generateSlug(newTitle));
    }
    // Auto-populate meta title if empty
    if (!metaTitle) {
      setMetaTitle(newTitle);
    }
  };
  const generateSlug = (text: string) => {
    return text.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').trim();
  };
  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newContent = e.target.value;
    setContent(newContent);
    // Auto-populate meta description if empty and content is added
    if (!metaDescription && newContent.length > 10) {
      // Use first 150 characters of content for meta description
      setMetaDescription(newContent.replace(/<[^>]*>/g, '').substring(0, 150) + '...');
    }
    // Auto-populate excerpt if empty
    if (!excerpt && newContent.length > 10) {
      setExcerpt(newContent.replace(/<[^>]*>/g, '').substring(0, 120) + '...');
    }
  };
  const handleSubmit = async (e: React.FormEvent, isDraft = false) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      // For demo purposes, we'll just simulate saving
      await new Promise(resolve => setTimeout(resolve, 1500));
      // In a real app, you would send data to your API
      // const response = await fetch('http://localhost:3001/posts', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({
      //     title,
      //     content,
      //     category,
      //     excerpt,
      //     featuredImage,
      //     metaTitle,
      //     metaDescription,
      //     slug,
      //     status: isDraft ? 'draft' : 'published',
      //     date: new Date().toISOString(),
      //     author: localStorage.getItem('userName') || 'Admin'
      //   })
      // })
      setSaveSuccess(true);
      // Redirect after successful save
      setTimeout(() => {
        navigate('/admin');
      }, 1000);
    } catch (err) {
      console.error('Error saving post:', err);
    } finally {
      setIsSaving(false);
    }
  };
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userName');
    navigate('/admin/login');
  };
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-221">
      {/* Sidebar - Desktop */}
      <div className="hidden md:flex flex-col w-64 bg-gray-800 text-white" data-id="element-222">
        <div className="p-5 flex items-center border-b border-gray-700" data-id="element-223">
          <FeatherIcon size={24} className="text-amber-500 mr-3" data-id="element-224" />
          <h1 className="text-xl font-bold" data-id="element-225">Muthamia Admin</h1>
        </div>
        <nav className="flex-1 overflow-y-auto py-4" data-id="element-226">
          <Link to="/admin" className="flex items-center px-4 py-3 text-gray-300 hover:bg-gray-700" data-id="element-227">
            <HomeIcon size={18} className="mr-3" data-id="element-228" />
            <span data-id="element-229">Dashboard</span>
          </Link>
          <Link to="/admin" className="flex items-center px-4 py-3 bg-gray-700 text-amber-400" data-id="element-230">
            <BookOpenIcon size={18} className="mr-3" data-id="element-231" />
            <span data-id="element-232">Posts</span>
          </Link>
        </nav>
        <div className="p-4 border-t border-gray-700" data-id="element-233">
          <button onClick={handleLogout} className="flex items-center text-gray-300 hover:text-white w-full" data-id="element-234">
            <LogOutIcon size={18} className="mr-3" data-id="element-235" />
            <span data-id="element-236">Logout</span>
          </button>
        </div>
      </div>

      {/* Mobile header */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-40 bg-gray-800 text-white p-4 flex justify-between items-center" data-id="element-237">
        <div className="flex items-center" data-id="element-238">
          <FeatherIcon size={24} className="text-amber-500 mr-3" data-id="element-239" />
          <h1 className="text-lg font-bold" data-id="element-240">Muthamia Admin</h1>
        </div>
        <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-white focus:outline-none" data-id="element-241">
          {sidebarOpen ? <XIcon size={24} data-id="element-242" /> : <MenuIcon size={24} data-id="element-243" />}
        </button>
      </div>

      {/* Mobile sidebar */}
      {sidebarOpen && <div className="md:hidden fixed inset-0 z-30 bg-gray-800 pt-16 overflow-y-auto" data-id="element-244">
          <nav className="py-4" data-id="element-245">
            <Link to="/admin" className="flex items-center px-4 py-3 text-gray-300" onClick={() => setSidebarOpen(false)} data-id="element-246">
              <HomeIcon size={18} className="mr-3" data-id="element-247" />
              <span data-id="element-248">Dashboard</span>
            </Link>
            <Link to="/admin" className="flex items-center px-4 py-3 bg-gray-700 text-amber-400" onClick={() => setSidebarOpen(false)} data-id="element-249">
              <BookOpenIcon size={18} className="mr-3" data-id="element-250" />
              <span data-id="element-251">Posts</span>
            </Link>
            <div className="px-4 mt-6 pt-6 border-t border-gray-700" data-id="element-252">
              <button onClick={handleLogout} className="flex items-center text-gray-300 hover:text-white w-full py-3" data-id="element-253">
                <LogOutIcon size={18} className="mr-3" data-id="element-254" />
                <span data-id="element-255">Logout</span>
              </button>
            </div>
          </nav>
        </div>}

      {/* Main Content */}
      <div className="flex-1 md:ml-64 md:mt-0 mt-16" data-id="element-256">
        <div className="py-6 px-4 sm:px-6 lg:px-8" data-id="element-257">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-8" data-id="element-258">
            <div data-id="element-259">
              <div className="flex items-center" data-id="element-260">
                <Link to="/admin" className="mr-4 text-gray-500 hover:text-gray-700" data-id="element-261">
                  <ArrowLeftIcon size={20} data-id="element-262" />
                </Link>
                <h1 className="text-2xl font-bold text-gray-900" data-id="element-263">
                  Create New Post
                </h1>
              </div>
              <p className="mt-1 text-sm text-gray-500" data-id="element-264">
                Create a new blog post for your website
              </p>
            </div>
            <div className="mt-4 sm:mt-0 flex space-x-3" data-id="element-265">
              <button type="button" onClick={e => handleSubmit(e, true)} disabled={isSaving || !title} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-50" data-id="element-266">
                Save Draft
              </button>
              <button type="button" onClick={e => handleSubmit(e, false)} disabled={isSaving || !title || !content} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-50" data-id="element-267">
                {isSaving ? <>
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" data-id="element-268"></span>
                    Saving...
                  </> : <>
                    <SaveIcon size={16} className="mr-2" data-id="element-269" />
                    Publish
                  </>}
              </button>
            </div>
          </div>

          {saveSuccess && <div className="mb-6 p-4 bg-green-50 text-green-700 rounded-md flex items-center" data-id="element-270">
              <CheckIcon size={20} className="mr-2" data-id="element-271" />
              <span data-id="element-272">Post saved successfully!</span>
            </div>}

          <div className="bg-white shadow-md rounded-lg overflow-hidden" data-id="element-273">
            {/* Post Title */}
            <div className="p-6 border-b border-gray-200" data-id="element-274">
              <input type="text" value={title} onChange={handleTitleChange} placeholder="Post Title" className="w-full text-3xl font-bold border-0 focus:ring-0 focus:outline-none placeholder-gray-300" data-id="element-275" />
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200" data-id="element-276">
              <nav className="flex" data-id="element-277">
                <button onClick={() => setActiveTab('content')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'content' ? 'border-b-2 border-amber-500 text-amber-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-278">
                  Content
                </button>
                <button onClick={() => setActiveTab('seo')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'seo' ? 'border-b-2 border-amber-500 text-amber-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-279">
                  SEO
                </button>
                <button onClick={() => setActiveTab('settings')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'settings' ? 'border-b-2 border-amber-500 text-amber-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-280">
                  Settings
                </button>
              </nav>
            </div>

            {/* Content Tab */}
            {activeTab === 'content' && <div className="p-6" data-id="element-281">
                <div className="mb-6" data-id="element-282">
                  <div className="flex justify-between items-center mb-2" data-id="element-283">
                    <label className="block text-sm font-medium text-gray-700" data-id="element-284">
                      Featured Image
                    </label>
                    <button type="button" className="text-xs text-amber-600 hover:text-amber-700" data-id="element-285">
                      Choose from Media Library
                    </button>
                  </div>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center" data-id="element-286">
                    {featuredImage ? <div className="relative" data-id="element-287">
                        <img src={featuredImage} alt="Featured" className="max-h-48 mx-auto" data-id="element-288" />
                        <button type="button" onClick={() => setFeaturedImage('')} className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600" data-id="element-289">
                          <XIcon size={16} data-id="element-290" />
                        </button>
                      </div> : <>
                        <ImageIcon size={48} className="mx-auto text-gray-400 mb-4" data-id="element-291" />
                        <p className="text-sm text-gray-500 mb-4" data-id="element-292">
                          Drag and drop an image here or click to upload
                        </p>
                        <input type="text" placeholder="Or paste an image URL" value={featuredImage} onChange={e => setFeaturedImage(e.target.value)} className="w-full p-2 border border-gray-300 rounded-md" data-id="element-293" />
                      </>}
                  </div>
                </div>

                <div className="mb-6" data-id="element-294">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-295">
                    Content
                  </label>
                  <textarea value={content} onChange={handleContentChange} rows={15} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Write your post content here..." data-id="element-296"></textarea>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-297">
                    Tip: You can use Markdown formatting for headings, lists,
                    and more.
                  </p>
                </div>

                <div className="mb-6" data-id="element-298">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-299">
                    Excerpt
                  </label>
                  <textarea value={excerpt} onChange={e => setExcerpt(e.target.value)} rows={3} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Write a short excerpt for your post..." data-id="element-300"></textarea>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-301">
                    A short summary of your post that will appear on the blog
                    index page.
                  </p>
                </div>
              </div>}

            {/* SEO Tab */}
            {activeTab === 'seo' && <div className="p-6" data-id="element-302">
                <div className="mb-6" data-id="element-303">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-304">
                    Slug
                  </label>
                  <div className="flex items-center" data-id="element-305">
                    <span className="text-gray-500 mr-2" data-id="element-306">/blog/</span>
                    <input type="text" value={slug} onChange={e => setSlug(e.target.value)} className="flex-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="post-slug" data-id="element-307" />
                  </div>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-308">
                    The URL-friendly version of the post title.
                  </p>
                </div>

                <div className="mb-6" data-id="element-309">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-310">
                    Meta Title
                  </label>
                  <input type="text" value={metaTitle} onChange={e => setMetaTitle(e.target.value)} className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="SEO title (appears in search results)" data-id="element-311" />
                  <div className="mt-2 flex justify-between" data-id="element-312">
                    <p className="text-sm text-gray-500" data-id="element-313">
                      Recommended length: 50-60 characters
                    </p>
                    <p className={`text-sm ${metaTitle.length > 60 ? 'text-red-500' : 'text-gray-500'}`} data-id="element-314">
                      {metaTitle.length}/60
                    </p>
                  </div>
                </div>

                <div className="mb-6" data-id="element-315">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-316">
                    Meta Description
                  </label>
                  <textarea value={metaDescription} onChange={e => setMetaDescription(e.target.value)} rows={3} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="SEO description (appears in search results)" data-id="element-317"></textarea>
                  <div className="mt-2 flex justify-between" data-id="element-318">
                    <p className="text-sm text-gray-500" data-id="element-319">
                      Recommended length: 150-160 characters
                    </p>
                    <p className={`text-sm ${metaDescription.length > 160 ? 'text-red-500' : 'text-gray-500'}`} data-id="element-320">
                      {metaDescription.length}/160
                    </p>
                  </div>
                </div>

                <div className="p-4 border border-gray-200 rounded-md bg-gray-50 mb-6" data-id="element-321">
                  <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-322">
                    Search Engine Preview
                  </h3>
                  <div className="p-4 bg-white border border-gray-200 rounded-md" data-id="element-323">
                    <p className="text-blue-600 text-lg font-medium truncate" data-id="element-324">
                      {metaTitle || title || 'Post Title'}
                    </p>
                    <p className="text-green-700 text-sm" data-id="element-325">
                      www.muthamiacontent.com/blog/{slug || 'post-slug'}
                    </p>
                    <p className="text-gray-600 text-sm mt-1 line-clamp-2" data-id="element-326">
                      {metaDescription || excerpt || 'Post description will appear here...'}
                    </p>
                  </div>
                </div>
              </div>}

            {/* Settings Tab */}
            {activeTab === 'settings' && <div className="p-6" data-id="element-327">
                <div className="mb-6" data-id="element-328">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-329">
                    Category
                  </label>
                  <select value={category} onChange={e => setCategory(e.target.value)} className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-330">
                    <option value="" data-id="element-331">Select a category</option>
                    <option value="Business" data-id="element-332">Business</option>
                    <option value="News" data-id="element-333">News</option>
                    <option value="Sports" data-id="element-334">Sports</option>
                    <option value="Storytelling" data-id="element-335">Storytelling</option>
                  </select>
                </div>

                <div className="mb-6" data-id="element-336">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-337">
                    Tags
                  </label>
                  <div className="flex items-center" data-id="element-338">
                    <TagIcon size={16} className="text-gray-400 mr-2" data-id="element-339" />
                    <input type="text" className="flex-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Add tags separated by commas" data-id="element-340" />
                  </div>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-341">
                    Tags help categorize your content and improve
                    discoverability.
                  </p>
                </div>

                <div className="mb-6" data-id="element-342">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-343">
                    Publication Date
                  </label>
                  <div className="flex items-center" data-id="element-344">
                    <CalendarIcon size={16} className="text-gray-400 mr-2" data-id="element-345" />
                    <input type="date" defaultValue={new Date().toISOString().split('T')[0]} className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-346" />
                    <ClockIcon size={16} className="text-gray-400 ml-4 mr-2" data-id="element-347" />
                    <input type="time" defaultValue={new Date().toTimeString().slice(0, 5)} className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-348" />
                  </div>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-349">
                    Schedule this post to be published at a future date and
                    time.
                  </p>
                </div>

                <div className="mb-6" data-id="element-350">
                  <div className="flex items-center" data-id="element-351">
                    <input id="allow-comments" type="checkbox" className="h-4 w-4 text-amber-600 focus:ring-amber-500 border-gray-300 rounded" defaultChecked data-id="element-352" />
                    <label htmlFor="allow-comments" className="ml-2 block text-sm text-gray-700" data-id="element-353">
                      Allow comments on this post
                    </label>
                  </div>
                </div>

                <div className="mb-6" data-id="element-354">
                  <div className="flex items-center" data-id="element-355">
                    <input id="featured-post" type="checkbox" className="h-4 w-4 text-amber-600 focus:ring-amber-500 border-gray-300 rounded" data-id="element-356" />
                    <label htmlFor="featured-post" className="ml-2 block text-sm text-gray-700" data-id="element-357">
                      Mark as featured post
                    </label>
                  </div>
                  <p className="mt-2 text-sm text-gray-500 ml-6" data-id="element-358">
                    Featured posts appear prominently on your homepage.
                  </p>
                </div>
              </div>}
          </div>

          <div className="mt-6 flex justify-end space-x-3" data-id="element-359">
            <Link to="/admin" className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500" data-id="element-360">
              Cancel
            </Link>
            <button type="button" onClick={e => handleSubmit(e, false)} disabled={isSaving || !title || !content} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-50" data-id="element-361">
              {isSaving ? <>
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" data-id="element-362"></span>
                  Saving...
                </> : <>
                  <SaveIcon size={16} className="mr-2" data-id="element-363" />
                  Publish Post
                </>}
            </button>
          </div>
        </div>
      </div>
    </div>;
}